import * as React from 'react';
import { PaymentMethodType } from '../../core-types';
import { List, Li, Flex, Button, Text, IconBlik, IconCard } from '../index';
import { useStyledComponentsTheme } from '@urbaninfrastructure/react-ui-kit';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

export const PaymentMethodTypeList = ({
  selected,
  availablePaymentMethods,
  onSelect
}: {
  selected: PaymentMethodType | null;
  availablePaymentMethods: PaymentMethodType[];
  onSelect: (type: PaymentMethodType) => unknown;
}) => {
  const theme = useStyledComponentsTheme();

  return (
    <>
      <Text mb="xxs" typoStyle="xs" fontWeight="bold">
        <FormattedMessage
          id="components.PaymentMethodTypeList.title"
          defaultMessage="Select payment method"
        />
      </Text>
      <List
        border="1px solid"
        borderRadius="md"
        borderColor={theme.colors.borderGray}
      >
        {availablePaymentMethods.map((type, i) => {
          const isSelected = type === selected;
          return (
            <Li
              key={type}
              borderTop={i > 0 ? '1px solid' : null}
              borderColor={theme.colors.borderGray}
              paddingY={2}
              paddingX={4}
            >
              <Flex justifyContent="space-between" alignItems="center">
                <PaymentMethodTypeLabel type={type} />
                <Button
                  small
                  onClick={() => onSelect(type)}
                  variant={isSelected ? 'primary' : 'secondary'}
                >
                  {isSelected ? (
                    <FormattedMessage
                      id="components.PaymentMethodTypeList.selectedButton"
                      defaultMessage="Selected"
                    />
                  ) : (
                    <FormattedMessage
                      id="components.PaymentMethodTypeList.selectButton"
                      defaultMessage="Select"
                    />
                  )}
                </Button>
              </Flex>
            </Li>
          );
        })}
      </List>
    </>
  );
};

const PaymentMethodTypeLabel = ({ type }: { type: PaymentMethodType }) => {
  let title: JSX.Element | string;
  let icon: JSX.Element;
  if (type === 'blik') {
    title = 'BLIK';
    icon = <IconBlik />;
  } else {
    title = (
      <FormattedMessage
        id="components.PaymentMethodTypeList.card"
        defaultMessage="Payment card"
      />
    );
    icon = <IconCard />;
  }

  return (
    <Flex alignItems="center">
      <LogoWrapper>{icon}</LogoWrapper>
      <Text typoStyle={'xxs'} ml={2}>
        {title}
      </Text>
    </Flex>
  );
};

const LogoWrapper = styled.span`
  svg path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
